import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './AddDistrict.css';

const AddDistrict = () => {
  const [formData, setFormData] = useState({
    district_name: '',
    primary_color: '#3498db',
    secondary_color: '#2ecc71',
    primary_contact: '',
    contact_phone: '',
    contact_email: '',
    address: '',
    address_line_2: '',
    city: '',
    state: '',
    zip: '',
    school_website: '',
    subdomain: ''
  });
  const [logo, setLogo] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleFileChange = (e) => {
    setLogo(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const formDataToSend = new FormData();
      Object.keys(formData).forEach(key => {
        formDataToSend.append(key, formData[key]);
      });
      if (logo) {
        formDataToSend.append('logo', logo);
      }

      await axios.post('/api/districts', formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      navigate('/superadmin/districts');
    } catch (error) {
      setError(error.response?.data?.error || 'Failed to create district');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-district">
      <h2>Add District</h2>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label>District Name *</label>
            <input
              type="text"
              name="district_name"
              value={formData.district_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Subdomain *</label>
            <input
              type="text"
              name="subdomain"
              value={formData.subdomain}
              onChange={handleChange}
              required
              pattern="[a-z0-9-]+"
              title="Lowercase letters, numbers, and hyphens only"
            />
            <small>.backtoschoolforms.com</small>
          </div>
        </div>

        <div className="form-group">
          <label>Logo (JPG, PNG, WEBP)</label>
          <input
            type="file"
            accept="image/jpeg,image/jpg,image/png,image/webp"
            onChange={handleFileChange}
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Primary Color</label>
            <input
              type="color"
              name="primary_color"
              value={formData.primary_color}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Secondary Color</label>
            <input
              type="color"
              name="secondary_color"
              value={formData.secondary_color}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Primary Contact *</label>
            <input
              type="text"
              name="primary_contact"
              value={formData.primary_contact}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Contact Phone *</label>
            <input
              type="tel"
              name="contact_phone"
              value={formData.contact_phone}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label>Contact Email *</label>
          <input
            type="email"
            name="contact_email"
            value={formData.contact_email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Address *</label>
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Address Line 2</label>
          <input
            type="text"
            name="address_line_2"
            value={formData.address_line_2}
            onChange={handleChange}
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>City *</label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>State *</label>
            <input
              type="text"
              name="state"
              value={formData.state}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Zip *</label>
            <input
              type="text"
              name="zip"
              value={formData.zip}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label>School Website</label>
          <input
            type="url"
            name="school_website"
            value={formData.school_website}
            onChange={handleChange}
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Creating...' : 'Create District'}
          </button>
          <button 
            type="button" 
            className="btn-secondary" 
            onClick={() => navigate('/superadmin/districts')}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddDistrict;

